// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1ZjEr","boxTitle":"Qualiphy_boxTitle__2ArsK","box":"Qualiphy_box__3lQnR","toggleWrap":"Qualiphy_toggleWrap__1wl0y"};